import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { services } from 'core/nft/data-access'
import { useMemoizedFn, useMountedPromiseFn, useDetailState } from 'shared/hooks'

import type { NftDetail } from '../models'

export const useNftDetail = () => {
    const [detail, setDetail] = useDetailState<NftDetail>()

    const getDetailApi = useMountedPromiseFn(services.getDetail)
    const getDetail = useMemoizedFn((id: NftDetail['id']) => {
        setDetail({ loading: true })
        return getDetailApi(id)
            .then(detail => {
                setDetail({ loading: false, detail })
                return detail
            })
            .catch(err => {
                setDetail({ loading: false })
                return Promise.reject(err)
            })
    })

    const syncDataApi = useMountedPromiseFn(services.syncData)
    const syncData = useMemoizedFn((token_address: string, token_id: string) => {
        setDetail({ loading: true })
        return syncDataApi(token_address, token_id)
            .then(detail => {
                setDetail({ loading: false })
                return detail
            })
            .catch(err => {
                setDetail({ loading: false })
                return Promise.reject(err)
            })
    })

    const { id } = useParams<{ id: NftDetail['id'] }>()
    useEffect(() => {
        id && getDetail(id).catch()
    }, [getDetail, id])

    return {
        ...detail,
        methods: { getDetail, syncData }
    }
}
